import { isAuthCheckedState } from "@/state";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import qs from "qs";

const AuthGuard = () => {
  const navigate = useNavigate();
  const [isAuthChecked] = useRecoilState(isAuthCheckedState);
  const location = useLocation();

  useEffect(() => {
    if (!isAuthChecked) {
      navigate(
        {
          pathname: "/login",
          search: qs.stringify({
            auth_check: "true",
            pathname: location.pathname + location.search,
          }),
        },
        { replace: true },
      );
    }
  }, []);

  return <Outlet />;
};

export default AuthGuard;
